import React, { Component } from "react";

class StoryClearAll extends Component{
    constructor(props) {
        super(props);
        this.state = {
            
        }
    }
    
    componentDidMount() {

    }
    componentWillUnmount() {
        
    }

    render(){
        return(
            <React.Fragment>

            </React.Fragment>
        )
    }
}
export default StoryClearAll;
